import { render, staticRenderFns } from "./TotalDiscountBox.vue?vue&type=template&id=4ec732ee&"
import script from "./TotalDiscountBox.vue?vue&type=script&lang=js&"
export * from "./TotalDiscountBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports